"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.actionReducerMap = exports.setApiBusyAction = void 0;

var _reduxUtils = require("@dealersocket/redux-utils");

var _apiBusy = require("../api-busy.reducer");

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var SET_API_BUSY = _apiBusy.apiBusyReducer.suffixKey('SET_API_BUSY');

var setApiBusyAction = (0, _reduxUtils.createAction)(SET_API_BUSY);
exports.setApiBusyAction = setApiBusyAction;

var actionReducerMap = _defineProperty({}, SET_API_BUSY, function (slice, action) {
  var isApiBusy = !!action.payload;
  return isApiBusy;
});

exports.actionReducerMap = actionReducerMap;

_apiBusy.apiBusyReducer.addActionReducerMap(actionReducerMap);